import axioslib, { AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthInterceptor } from "./AuthInterceptor";
import VersionInterceptor from "@/api/VersionInterceptor";
import { INews } from "@iloq/shared";
import { Logger } from "@iloq/shared";

export default class NewsApi {
  private readonly axios: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    AuthInterceptor.setAuthInterceptors(this.axios);
    VersionInterceptor.setVersionInterceptor(this.axios);
  }

  fetchNews(languageCode: string): Promise<INews[]> {
    const options: AxiosRequestConfig = {
      method: "GET",
      url: `/api/v1/news/news/${languageCode}`,
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("NewsApi.fetchNews failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("NewsApi.fetchNews result:", JSON.stringify(result.data));
        return result.data as INews[];
      });
  }

  fetchBlogPosts(languageCode: string): Promise<INews[]> {
    const options: AxiosRequestConfig = {
      method: "GET",
      url: `/api/v1/news/blogposts/${languageCode}`,
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("NewsApi.fetchBlogPosts failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("NewsApi.fetchBlogPosts result:", JSON.stringify(result.data));
        return result.data as INews[];
      });
  }
}
